import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { AppState, ErrorAction } from 'store';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';
import { BasketActions, BasketActionTypes, LoadingItemTypes } from 'store/basket/basket.types';
import { validateCartSaga, loadBasketSaga, initBasketPageSaga, removeAllSofashieldsQueueSaga, removeAllInvalidBasketItemsQueueSaga } from '../../actions';

export interface RemoveInvalidItemsAction extends Action<BasketActionTypes.REMOVE_INVALID_ITEMS> {
    isBasketPage?: boolean;
}

export interface RemoveInvalidItemsActionStart extends Action<BasketActionTypes.REMOVE_INVALID_ITEMS_START> {
}

export interface RemoveInvalidItemsActionSuccess extends Action<BasketActionTypes.REMOVE_INVALID_ITEMS_SUCCESS> {
}

export interface RemoveInvalidItemsActionError extends ErrorAction<BasketActionTypes.REMOVE_INVALID_ITEMS_ERROR> {
}

export const removeInvalidItems: (isBasketPage?: boolean) => RemoveInvalidItemsAction = (isBasketPage?: boolean) => ({
    type: BasketActionTypes.REMOVE_INVALID_ITEMS,
    isBasketPage
});
removeInvalidItems[ACTION_CREATOR_NAME] = 'removeInvalidItems';
export type RemoveInvalidItemsFunc = (...args: Parameters<typeof removeInvalidItems>) => void;

export function* removeInvalidItemsSaga({ isBasketPage }: RemoveInvalidItemsAction): BasketSagaReturnType {
    try {
        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_INVALID_ITEMS_START
        });

        let state: AppState = yield select();
        const invalidItems = state.basketState.validationResult.invalidItems;
        let sofaShields = state.basketState.validationResult.sofaShields;

        if ((!invalidItems || !invalidItems.length) && (!sofaShields || !sofaShields.length)) {
            yield put<BasketActions>({
                type: BasketActionTypes.REMOVE_INVALID_ITEMS_SUCCESS
            });

            return true;
        }

        if (sofaShields && sofaShields.length > 0) {
            if (invalidItems.length > 0) {
                sofaShields = sofaShields.filter(sofaShield => !invalidItems.some(invalidItem => invalidItem.product.code === sofaShield.product.code));
            }

            yield callBasketSaga(removeAllSofashieldsQueueSaga, {
                type: BasketActionTypes.REMOVE_ALL_SOFASHIELDS,
                loadingItems: sofaShields.map(entry => ({ id: entry.product.code, loadingType: LoadingItemTypes.RemoveAllSofashields }))
            });
        }

        if (invalidItems && invalidItems.length > 0) {
            yield callBasketSaga(removeAllInvalidBasketItemsQueueSaga, {
                type: BasketActionTypes.REMOVE_ALL_INVALID_ITEMS,
                loadingItems: invalidItems.map(entry => ({ id: entry.product.code, loadingType: LoadingItemTypes.RemoveItem }))
            });
        }

        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_INVALID_ITEMS_SUCCESS
        });

        if (isBasketPage) {
            yield callBasketSaga(initBasketPageSaga, {
                type: BasketActionTypes.INIT_BASKET_PAGE
            });
        }

        return true;
    } catch (error) {
        try {
            yield callBasketSaga(loadBasketSaga);
            yield callBasketSaga(validateCartSaga,{ type: BasketActionTypes.VALIDATE_CART, isBasketPage: isBasketPage });
            yield callBasketSaga(removeInvalidItemsSaga, { type: BasketActionTypes.REMOVE_INVALID_ITEMS, isBasketPage: isBasketPage });
        } catch (err) {

            yield put<BasketActions>({
                type: BasketActionTypes.SET_SHOW_INVALID_ITEMS_REMOVING_WARNING,
                shouldShowInvalidItemsRemovingWarning: false
            });

            yield put<BasketActions>({
                type: BasketActionTypes.REMOVE_INVALID_ITEMS_ERROR,
                error: errorToBasketErrorModel(err, 'removeInvalidItemsSaga')
            });

            return false;
        }

        return true;
    }
}